/**
 * Firebase web config — public values only. Same project as the React
 * Native app (doctors-journal) but uses the WEB API key (publicly
 * exposable; security is via Firestore + Functions auth rules).
 *
 * CO 2026-06-01.
 */
export const firebaseWebConfig = {
  apiKey: 'AIzaSyC2rpMATLhzUtF2lGWtLfawcNIYZxu0mm8',
  authDomain: 'doctors-journal.firebaseapp.com',
  projectId: 'doctors-journal',
  storageBucket: 'doctors-journal.firebasestorage.app',
  messagingSenderId: '368347266811',
  appId: '1:368347266811:web:33e10e744efafaca8aba5e',
} as const;

/** All Cloud Functions live in this region. */
export const FUNCTIONS_REGION = 'australia-southeast1';
